// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"311":"4d70e960","571":"4d70e960","924":"4d70e960"}[chunkId] + ".chunk.css";
};